

































































import { Component, Ref, Vue, Emit, Prop, Watch } from 'vue-property-decorator';

@Component
export default class HelloWord extends Vue {
  @Prop(Array) performanceOrderVOs;
  @Prop(String) consigneeName;
  form: any = {
    name: '123'
  };
}
